import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { AuditLog, AuditLogFilters, SystemLogsListParams } from '../types';

const { AUDIT_LOGS } = API_ENDPOINTS;

export const systemLogsApi = {
  getAll: (params?: SystemLogsListParams) =>
    apiClient.getPaginated<AuditLog>(AUDIT_LOGS.LIST, params),

  getLatest: () => apiClient.get<AuditLog[]>(AUDIT_LOGS.LATEST),

  getFilters: () => apiClient.get<AuditLogFilters>(AUDIT_LOGS.FILTERS),

  create: (data: { action: string; meta?: Record<string, unknown> }) =>
    apiClient.post(AUDIT_LOGS.CREATE, data)
};
